import { Account, ClosedPosition, OpenPosition } from '@monorepo/types';

/**
 * Enum for different position view types that can be displayed in the trades table.
 */
export enum PositionViewType {
  OPEN = 'open',
  CLOSED = 'closed',
  BOTH = 'both',
}

/**
 * Props interface for useTradesTableData hook.
 */
export interface UseTradesTableDataProps {
  accountId: string;
  account?: Account; // Optional full account object for status checking
  page?: number;
  limit?: number;
}

/**
 * Configuration object for processing position data by view type.
 */
export interface ViewConfig {
  type: PositionViewType;
  data: (ClosedPosition | OpenPosition)[];
  total: number;
  isLoading: boolean;
}

/**
 * Return type for processed position data.
 */
export interface ProcessedPositionsData {
  positions: (OpenPosition | ClosedPosition)[];
  isLoading: boolean;
  totalCount: number;
}
